import initialState from 'redux/initialState';
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { Folder } from 'types';

type FolderAction = {
  type: string;
  folders?: Folder[];
  folder?: Folder;
  folderId?: string;
};

const resetStateSociety = () => initialState.tradingOffers;

const getFolders = (action: FolderAction) => action.folders;

const createFolder = (folders: Folder[], action: FolderAction) => [
  action.folder,
  ...folders,
];

const updateFolder = (folders: Folder[], action: FolderAction) =>
  folders?.map((folder: Folder) =>
    folder._id === action?.folder?._id ? action.folder : folder
  );

const deleteFolder = (folders: Folder[], action: FolderAction) =>
  folders?.filter((folder: Folder) => folder._id !== action.folderId);

export default function reducer(
  folders = initialState.folders,
  action: FolderAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.GET_FOLDERS: {
      return getFolders(action);
    }
    case actionTypes.CREATE_FOLDER:
      return createFolder(folders, action);

    case actionTypes.UPDATE_FOLDER:
      return updateFolder(folders, action);

    case actionTypes.DELETE_FOLDER:
      return deleteFolder(folders, action);

    default:
      return folders;
  }
}
